// extracted by mini-css-extract-plugin
export default {"root":"Table_root__qBHLT","tableRow":"Table_tableRow__igikT","tableCell":"Table_tableCell__LrG8a"};